import { gql } from '@apollo/client';

const TaxCatalogPreflightInfo = gql`
  fragment TaxCatalogPreflightInfo on TaxCatalogPreflight {
    activeProductCount
    approvedProductCount
    blockedProductCount
    blockedProductIds
    bundledProductCount
    codedProductCount
    expiredResaleExemptionCount
    expiringEvidenceCount
    expiringEvidenceIds
    inactiveProviderCodeCount
    inactiveProviderCodeProductIds
    intentionallyFullyTaxableCount
    openReviewCount
    openReviewProductIds
    staleSuccessorCount
    staleSuccessorProductIds
    upcomingRenewalBlockerCount
    upcomingRenewalBlockerIds
    validResaleExemptionCount
    csvExport {
      base64Data
      contentType
      filename
    }
  }
`;

export default TaxCatalogPreflightInfo;
